<template>
    <LoaderGradientBackground class="price-loader" />
</template>

<script>

import LoaderGradientBackground from '~/src/components/ui/Loader/LoaderGradientBackground';

export default {
    name: 'PriceLoaderProductTail',
    components: { LoaderGradientBackground },
};
</script>

<style lang="scss">
    .price-loader {
        height: 100%;
        width: 100%;
    }
</style>
